




































































import {Component} from 'vue-property-decorator'
import Utils from '@/utils'
import VehicleAddReport from '@/views/Vehicle/VehicleAddReport.vue'
import {EventBus} from '@/main'
import {ReservationResponse} from '@/lib/kepler/interfaces'

@Component({
  components: {
    VehicleDamage: Utils.loadComponent('entities/vehicle/VehicleDamage'),
    FullListHistory: Utils.loadView('Vehicle/VehicleAddReport'),
    SelectTag: Utils.loadComponent('proxy/Inputs/SelectTag'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    TextArea: Utils.loadComponent('proxy/Inputs/TextArea'),
    FormTag: Utils.loadComponent('proxy/Inputs/FormTag'),
    Container: Utils.loadComponent('proxy/Container'),
    CloseButton: Utils.loadComponent('CloseButton'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Icon: Utils.loadComponent('proxy/Icon'),
    Button: Utils.loadComponent('Button'),
  },
  name: 'VehicleAddReportDialog',
  extends: VehicleAddReport,
})
export default class VehicleAddReportDialog extends VehicleAddReport {
  protected openReportDialog(r: ReservationResponse) {
    this.$dialog.open(VehicleAddReportDialog, {
      props: {vehicle: r.vehicle_slot.vehicle},
      title: this.$t('vehicle.report.diary_report'),
    })
  }

  protected send() {
    if (this.vehicle) {
      this.reportRequest.vehicle_id = this.vehicle.id
      this.loading = true
      if (this.parkingReport) {
        this.reportRequest.description = this.$t('vehicle.report.park_occupied_full', {
          streetName: this.streetName,
          streetNumber: this.streetNumber,
        })
      } else if (this.pictureReport) {
        this.reportRequest.description = '-'
      }
      if (!navigator.onLine) {
        this.sendReport(this.reportRequest).finally(() => {
          EventBus.$emit('sentReport')
          this.$dialog.close()
        })
      }
      this.sendReport(this.reportRequest).then(() => {
        EventBus.$emit('sentReport')
        this.$dialog.close()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
